import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LeftIcon from "../../assets/svgs/leftArrowIcon.svg";
import RightIcon from "../../assets/svgs/rightArrowIcon.svg";
import AcquisitionTab from "../../components/DetailTabsData/AcquisitionTab";
import PortfolioTab from "../../components/DetailTabsData/PortfolioTab";
import PropertyTab from "../../components/DetailTabsData/PropertyTab";
import SmartPlanTab from "../../components/DetailTabsData/SmartPlanTab";
import TaskTab from "../../components/DetailTabsData/TaskTab";
import Loader from "../../components/Loader";
import SearchDropdownList from "../../components/SearchDropdownList";
import { ROUTES } from "../../routes/routeKeys";
import useAuth from "../../hooks/useAuth";
import BaseLayout from "../../layouts/BaseLayout";
import { BASE_URL } from "../../utils/Element";
import DetailsHeader from "./components/DetailsHeader";
import OffersTabData from "./components/OffersTabData";
import UpdateTabData from "./components/UpdateTabData";


const ContactDetails = () => {
  const { id } = useParams();
  const [config] = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("updates");
  const [contactDetails, setContactDetails] = useState();
  const queryParams = new URLSearchParams(location.search);
  const searchValue = queryParams.get('search');

 const fetchContactDetails = () => {
  setLoading(true);

  const savedQueryParams = localStorage.getItem("queryParams");
  const savedAdvanceFilters = localStorage.getItem("advanceFilterData");

  // Build clean payload for POST body
  const payload = {};

  // 1. Parse all normal filters (search, sort, page, etc.)
  if (savedQueryParams) {
    const params = new URLSearchParams(savedQueryParams);
    params.forEach((value, key) => {
      if (key !== "advance_filters") {
        payload[key] = value;
      }
    });
  }

  // 2. Add advance filters as REAL ARRAY (this is what makes Previous/Next work)
  if (savedAdvanceFilters) {
    try {
      const advanceFilters = JSON.parse(savedAdvanceFilters);
      if (Array.isArray(advanceFilters) && advanceFilters.length > 0) {
        payload.advance_filters = advanceFilters;
      }
    } catch (e) {
      console.warn("Failed to parse advanceFilterData:", e);
    }
  }

  axios
    .post(`${BASE_URL}/contact-getbyid/${id}`, payload, config)
    .then((res) => {
      setContactDetails(res?.data?.data);
    })
    .catch((err) => {
      if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
        NotificationManager.error(err.response?.data?.message);
      }
    })
    .finally(() => setLoading(false));
};
  
  useEffect(() => {
    fetchContactDetails();
  }, [id]);

  return (
    <BaseLayout>
      <div className="flex justify-between items-center">
        <p role="button" className="green-H head-5 underline" onClick={() => navigate(`${ROUTES.CONTACTS}?search=${searchValue || ''}`)}>
          Back to Contacts
        </p>

        <div className="body-S dark-M flex items-center gap-5">
          {contactDetails?.previous_id !== null && (
            <div role="button" onClick={() => navigate(ROUTES.CONTACT_DETAILS.replace(":id", contactDetails?.previous_id))} className="flex items-center gap-2">
              <img src={LeftIcon} alt="" />
              Previous Contact
            </div>
          )}

          {contactDetails?.next_id !== null && (
            <div role="button" onClick={() => navigate(ROUTES.CONTACT_DETAILS.replace(":id", contactDetails?.next_id))} className="flex items-center gap-2">
              Next Contact
              <img src={RightIcon} alt="" />
            </div>
          )}
        </div>

        <SearchDropdownList from="contact" />
      </div>

      <div className="relative">
        {loading && (
          <div className="absolute inset-0 z-20 flex justify-center items-center bg-white/40 backdrop-blur-[1px] rounded-xl">
            <Loader />
          </div>
        )}
        
        <DetailsHeader contactDetails={contactDetails} onSetCallApiAgain={fetchContactDetails} />

        <div className="contact-details light-bg-L rounded-xl min-h-[500px]" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
            <div className="flex justify-between header-tabs">
              <p role="button" onClick={() => setActiveTab("updates")} className={`${activeTab === "updates" ? "head-5 dark-H active" : "body-S dark-M "} tab`}>
                Updates
              </p>
              <p role="button" onClick={() => setActiveTab("properties")} className={`${activeTab === "properties" ? "head-5 dark-H active" : "body-S dark-M"} tab`}>
                Properties
              </p>
                <p role="button" onClick={() => setActiveTab("portfolio")} className={`${activeTab === "portfolio" ? "head-5 dark-H active" : "body-S dark-M"} tab`}>
                Portfolio
              </p>
              <p role="button" onClick={() => setActiveTab("acquisition")} className={`${activeTab === "acquisition" ? "head-5 dark-H active" : "body-S dark-M"} tab`}>
                Acquisition Criteria
              </p>
              <p role="button" onClick={() => setActiveTab("offers")} className={`${activeTab === "offers" ? "head-5 dark-H active" : "body-S dark-M"} tab`}>
                Offers
              </p>
              <p role="button" onClick={() => setActiveTab("tasks")} className={`${activeTab === "tasks" ? "head-5 dark-H active" : "body-S dark-M"} tab`}>
                Tasks
              </p>
              <p role="button" onClick={() => setActiveTab("smartPlans")} className={`${activeTab === "smartPlans" ? "head-5 dark-H active" : "body-S dark-M"} tab`}>
                TouchPlans
              </p>
             
            </div>

            <div className="p-4" key={id}>
              {activeTab === "updates" && <UpdateTabData parentLoading={loading} />}
              {activeTab === "properties" && <PropertyTab from="contact" />}
               {activeTab === "portfolio" && <PortfolioTab from="contact" />}
              {activeTab === "acquisition" && <AcquisitionTab from="contact" />}
              {activeTab === "offers" && <OffersTabData />}
              {activeTab === "tasks" && <TaskTab from="contact" data={contactDetails} />}
              {activeTab === "smartPlans" && <SmartPlanTab from="contact" />}
             
            </div>
          </div>
      </div>
    </BaseLayout>
  );
};

export default ContactDetails;
